// @ts-nocheck
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getSndProductsByParentSku } from "@store/Framework/Services/ScratchAndDentService";
import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = GetProductCollectionApiV2Parameter &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string> & { widgetId: string };
type Props = {
    apiParameter: GetProductCollectionApiV2Parameter & { apiType?: string };
    apiResult: ProductModel[] | undefined | null;
    productInfos?: ProductInfo[];
};

type HandlerType = Handler<Parameter, Props>;

export const StartProductInfoLists: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductInfoLists/SetWaitingForData",
        id: props.parameter.widgetId,
        parameter: {
            productId: props.parameter!.productIds![0],
        } as GetProductCollectionApiV2Parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...parameter } = props.parameter;
    props.apiParameter = { ...parameter };
};

export const DispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/BeginLoadProducts",
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSndProductsByParentSku({ id: props.parameter!.productIds![0] as any });
    } catch (error) {
        props.parameter.onError?.(error);
    }
};

export const DispatchCompleteLoadProducts: HandlerType = props => {
    if (!props.apiResult || !props.apiResult.length) {
        return;
    }
    props.dispatch({
        type: "Data/Products/CompleteLoadProducts",
        collection: { products: props.apiResult } as any,
        parameter: props.parameter,
    });
};

export const SetUpProductInfos: HandlerType = props => {
    if (!props.apiResult || !props.apiResult.length) {
        return;
    }

    props.productInfos = [];
    for (const product of props.apiResult) {
        props.productInfos.push(createFromProduct(product));
    }

    props.dispatch({
        type: "Components/ProductInfoLists/CompleteLoadProductInfoList",
        id: props.parameter.widgetId!,
        parameter: {
            productId: props.parameter!.productIds![0],
        } as GetProductCollectionApiV2Parameter,
        productInfos: props.productInfos ?? [],
    });

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: props.productInfos,
            onSuccess: realTimePricing => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimePricing",
                    id: props.parameter.widgetId!,
                    realTimePricing,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
                    id: props.parameter.widgetId!,
                });
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );

    props.dispatch(
        loadRealTimeInventory({
            productIds: props.productInfos.map(o => o.productId),
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimeInventory",
                    id: props.parameter.widgetId!,
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimeInventory",
                    id: props.parameter.widgetId!,
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [
    StartProductInfoLists,
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    RequestDataFromApi,
    DispatchCompleteLoadProducts,
    SetUpProductInfos,
    ExecuteOnSuccessCallback,
];

const displaySndProducts = createHandlerChainRunner(chain, "DisplaySndProducts");
export default displaySndProducts;
